import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { Lock, LockOpen } from "@material-ui/icons";
import { removeAllExcludePolygon } from "store/features";
import { selectViewLock, useMapStore } from "stores/map";
import styled from "styled-components";

import { ToolbarButton } from "components/base";
import { useGeomBinContext } from "components/geom-bin/hooks/useGeomBinContext";

import { useMapContext } from "../hooks/useMapContext";
import { useMapDispatch } from "../hooks/useMapDispatch";

export interface MapLockComponentModel {
  getAndSetFeaturesIntersectingPolygon;
  mapSyncRef;
  setMapSync;
  // eslint-disable-next-line no-unused-vars
  onMapLockChanged: (val: boolean) => void;
}

export default function MapLock({
  mapSyncRef,
  setMapSync,
  onMapLockChanged
}: MapLockComponentModel) {
  const { mapbox } = useMapContext();
  const dispatch = useDispatch();
  const mapDispatch = useMapDispatch();
  const setViewLock = useMapStore((s) => s.setViewLock);
  const viewLockState = useMapStore(selectViewLock);
  const { isActive: isGeomBinOpen } = useGeomBinContext();

  async function lockCurrentView() {
    if (!mapbox) return;
    mapDispatch({
      payload: {
        selectedFeatures: []
      }
    });
  }
  function cancelViewLock() {
    if (!mapbox) {
      return;
    }
    mapSyncRef.current = true;
    setMapSync(mapSyncRef.current);
    mapbox.fire("viewLockCancel", {});
    dispatch(removeAllExcludePolygon());
  }
  useEffect(() => {
    onMapLockChanged && onMapLockChanged(viewLockState);
    setViewLock(viewLockState);
    if (viewLockState) {
      lockCurrentView();
    } else {
      cancelViewLock();
    }
  }, [viewLockState]);
  if (!mapbox || isGeomBinOpen) {
    return <></>;
  }

  return (
    <ToolbarButton
      active={viewLockState}
      activeIcon={
        <IconWrapper>
          <Lock fontSize="inherit" />
        </IconWrapper>
      }
      data-testid="map-lock"
      icon={
        <IconWrapper>
          <LockOpen fontSize="inherit" />
        </IconWrapper>
      }
      onToggle={(v) => {
        setViewLock(v);
      }}
      overflowLabel={"Polygon Lock"}
      styleKey="mapToolbar"
      tooltipText="Polygon Lock"
    />
  );
}

const IconWrapper = styled.div`
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
